import { render } from "./TagRoleFilterModal.vue?vue&type=template&id=599396b3&scoped=true"
import script from "./TagRoleFilterModal.vue?vue&type=script&lang=js"
export * from "./TagRoleFilterModal.vue?vue&type=script&lang=js"

import "./TagRoleFilterModal.vue?vue&type=style&index=0&id=599396b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-599396b3"]])

export default __exports__